import React, { createContext, useContext, useState } from 'react';

const SelectionContext = createContext(null);

export const useSelection = () => {
  const context = useContext(SelectionContext);
  if (!context) {
    throw new Error('useSelection must be used within SelectionProvider');
  }
  return context;
};

export const SelectionProvider = ({ children }) => {
  const [selectedDiamonds, setSelectedDiamonds] = useState([]);

  const addDiamond = (diamond) => {
    setSelectedDiamonds(prev => {
      if (prev.find(d => d.diamond_id === diamond.diamond_id)) {
        return prev;
      }
      return [...prev, diamond];
    });
  };

  const removeDiamond = (diamondId) => {
    setSelectedDiamonds(prev => prev.filter(d => d.diamond_id !== diamondId));
  };

  const toggleDiamond = (diamond) => {
    if (selectedDiamonds.find(d => d.diamond_id === diamond.diamond_id)) {
      removeDiamond(diamond.diamond_id);
    } else {
      addDiamond(diamond);
    }
  };

  const clearSelection = () => {
    setSelectedDiamonds([]);
  };

  const isSelected = (diamondId) => {
    return selectedDiamonds.some(d => d.diamond_id === diamondId);
  };

  return (
    <SelectionContext.Provider value={{
      selectedDiamonds,
      addDiamond,
      removeDiamond,
      toggleDiamond,
      clearSelection,
      isSelected,
      count: selectedDiamonds.length
    }}>
      {children}
    </SelectionContext.Provider>
  );
};
